import { render } from "./BanksPayment.vue?vue&type=template&id=fca90e86&ts=true"
import script from "./BanksPayment.vue?vue&type=script&lang=ts"
export * from "./BanksPayment.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/cibweb-v2-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__